// @flow
/* eslint-disable no-shadow */
import React from 'react';
import { connect } from 'react-redux';
import MicSelectorContainer from '../../modules/scribe/MicSelectorContainer';

function CaptionsSettings({
  currentPlatform,
  displayable,
  inTwilioCalls,
  isInConversation,
  muted,
  scribe,
}: {
  currentPlatform: string,
  displayable: Object,
  inTwilioCalls: boolean,
  isInConversation: boolean,
  muted: Boolean,
  scribe: string,
}) {
  if (currentPlatform === 'web' && !muted && !scribe && isInConversation && !inTwilioCalls && displayable.audio) {
    return <MicSelectorContainer />;
  }
  return null;
}

const mapStateToProps = ({
  scribeConversation: { inTwilioCalls, isInConversation, muted, scribe },
  scribeSession: { currentPlatform, displayable },
}) => ({
  currentPlatform,
  displayable,
  inTwilioCalls,
  isInConversation,
  muted,
  scribe,
});

export default connect(mapStateToProps, {})(CaptionsSettings);
